import React from 'react';
import { FormAlerts, Button, Field } from '@cordata/buffet';
import { Card, CardBody, CardFooter, Alert } from 'reactstrap';
import { Formik, Form } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Yup from 'yup';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import kebabcaseKeys from 'kebabcase-keys';

import { baseInstance as axios } from '~/utils';

const initialValues = {
  code: '',
};

const validationSchema = Yup.object().shape({
  code: Yup.string().required(),
});

const B2WConfirmRegistrationForm = () => {
  const location = useLocation();

  return (
    <Formik
      displayName="B2WConfirmRegistrationFormik"
      validateOnBlur={false}
      validateOnChange={false}

      initialValues={{
        code: location.search && queryString.parse(location.search).code,
      }}
      initalStatus={{ success: false }}

      validationSchema={validationSchema}

      onSubmit={(values, {
        setStatus, setErrors, setSubmitting,
      }) => {
        const p = {
          ...values,
          ...JSON.parse(localStorage.getItem('registration-info')),
        };

        axios
          .post(
            '/b2w/validate',
            kebabcaseKeys(p, { deep: true }),
          )
          .then(() => {
            localStorage.setItem('registration-code', values.code);

            setStatus({ success: true });

            window.location.reload();
          })
          .catch((e) => {
            const errs = e.response ? e.response.data.errors : e;

            setErrors({ server: e });

            if (
              errs &&
              Object.keys(errs).some(er =>
                Object.keys(values).includes(er))
            ) {
              Object.keys(errs).forEach(er =>
                setErrors({ [er]: errs[er] !== 'Required' ? errs[er] : 'is required' }));
            }
          })
          .then(() => setSubmitting(false));
      }}
    >
      {({
        errors,
        status,
        handleReset,
        submitCount,
        isSubmitting,
      }) => (
        <Card>
          <Form noValidate>
            <CardBody>
              <Alert color="info">You should have received a text message with a code. Enter it below.</Alert>

              {submitCount >= 1 && errors && (
                <FormAlerts errors={errors} />
              )}

              {status && status.success && (<Alert color="success">Form Sent!</Alert>)}

              <Field
                name="code"
                required
              />
            </CardBody>

            <CardFooter className="d-flex">
              <div className="mr-auto">
                <Button
                  color="danger"
                  type="button"
                  outline
                  disabled={isSubmitting}
                  onClick={() =>
                    handleReset(initialValues)}
                >
                  <FontAwesomeIcon icon="sync-alt" />
                  <span className="d-none d-md-inline ml-2">Reset</span>
                </Button>
              </div>

              <div className="ml-auto">
                <Button
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Saving ...' : 'Save'}
                </Button>
              </div>
            </CardFooter>
          </Form>
        </Card>
      )}
    </Formik>
  );
};

export default B2WConfirmRegistrationForm;
